import Immutable from 'immutable';

const CourseRecord = Immutable.Record({
  id: undefined,
  name: undefined,
  isActive: undefined,
  displayOrder: undefined,
});

export default class Course extends CourseRecord { }



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/StudyPlan/course/model.js